// components/layout/Navbar/styles.js
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Container, Button } from "../../../styles/components";

export const NavWrapper = styled.header`
	height: 72px;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	background: ${(props) =>
		props.isScrolled
			? props.theme.colors.background.paper
			: props.isTransparent
			? "transparent"
			: props.theme.colors.background.paper};
	backdrop-filter: ${(props) => (props.isScrolled ? "blur(8px)" : "none")};
	transition: all ${(props) => props.theme.transitions.normal};
	box-shadow: ${(props) =>
		props.isScrolled ? props.theme.shadows.sm : "none"};
`;

export const NavContainer = styled(Container)`
	height: 72px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const Logo = styled(Link)`
	font-size: ${(props) => props.theme.typography.sizes.xl};
	font-weight: ${(props) => props.theme.typography.weights.bold};
	color: ${(props) => props.theme.colors.primary.main};
	transition: color ${(props) => props.theme.transitions.fast};
`;

export const NavLinks = styled.nav`
	display: none;

	@media (min-width: ${(props) => props.theme.breakpoints.md}) {
		display: flex;
		align-items: center;
		gap: ${(props) => props.theme.spacing.lg};
	}
`;

export const NavLink = styled(Link)`
	font-size: ${(props) => props.theme.typography.sizes.md};
	font-weight: ${(props) => props.theme.typography.weights.medium};
	color: ${(props) => props.theme.colors.text.primary};
	padding: ${(props) => `${props.theme.spacing.sm} ${props.theme.spacing.md}`};
	border-radius: ${(props) => props.theme.borderRadius.md};
	transition: all ${(props) => props.theme.transitions.fast};

	&:hover {
		color: ${(props) => props.theme.colors.primary.main};
		background: ${(props) => props.theme.colors.primary.main}10;
	}
`;

export const MobileMenuButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	padding: 0;
	z-index: 1002;

	@media (min-width: ${(props) => props.theme.breakpoints.md}) {
		display: none;
	}
`;

export const MobileMenu = styled.div`
	display: ${(props) => (props.isOpen ? "flex" : "none")};
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100vw;
	height: 100vh;
	background: ${(props) => props.theme.colors.background.main};
	z-index: 1001;
	flex-direction: column;
	align-items: center;
	overflow-y: auto;

	& > * {
		width: 100%;
		min-height: 100%;
		background: ${(props) => props.theme.colors.background.main};
	}

	@media (min-width: ${(props) => props.theme.breakpoints.md}) {
		display: none;
	}
`;

export const MobileMenuContent = styled.div`
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${(props) => props.theme.spacing.xl};
	padding: ${(props) => props.theme.spacing["4xl"]}
		${(props) => props.theme.spacing.xl};
	background: ${(props) => props.theme.colors.background.main};
`;

export const MobileLogo = styled(Logo)`
	margin-bottom: ${(props) => props.theme.spacing["2xl"]};
	font-size: ${(props) => props.theme.typography.sizes["2xl"]};
`;

export const MobileNavLink = styled(NavLink)`
	font-size: ${(props) => props.theme.typography.sizes.xl};
	width: 100%;
	text-align: center;
	padding: ${(props) => props.theme.spacing.md};
`;
